import React, {
	useEffect,
	useState,
} from 'react';
import {
	Modal,
} from 'react-bootstrap';
import Button, {
	ButtonColor,
} from '../button';
import './modalWithFooter.scss';
import {
	ModalProps,
} from './modal-props.model';

interface Props extends ModalProps {
	onConfirmation: (
		/**
		 * Only relevant if you set doNotCloseOnConfirm to true.
		 */
		closeModal: () => void
	) => void;
	doNotCloseOnConfirm?: boolean;
	buttonTextConfirm?: string;
	buttonTextClose?: string;
	dataTestId?: string;
}

export const ModalWithFooter = ({
	dataTestId,
	title,
	buttonTextConfirm = 'Bekreft',
	buttonTextClose = 'Avbryt',
	show,
	isSubmitDisabled = false,
	doNotCloseOnConfirm = false,
	onConfirmation,
	onClose,
	children,
}: Props) => {
	const [isOpen, setIsOpen] = useState(false);

	const handleClose = () => {
		setIsOpen(false);
		onClose();
	};

	useEffect(() => {
		setIsOpen(show);
	}, [show]);

	return (
		<Modal
			data-testid={dataTestId}
			className="modal-with-footer"
			show={isOpen}
			onHide={() => {
				handleClose();
			}}
		>
			<Modal.Header closeButton />
			<Modal.Body>
				<div className="container">
					<div>
						<h5 className="title">
							{title}
						</h5>
					</div>

					{children}
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button
					color={ButtonColor.SECONDARY}
					onClick={() => {
						handleClose();
					}}
				>
					{buttonTextClose}
				</Button>
				<Button
					color={ButtonColor.PRIMARY}
					onClick={() => {
						if (!doNotCloseOnConfirm) {
							handleClose();
						}
						onConfirmation(() => handleClose());
					}}
					disabled={isSubmitDisabled}
				>
					{buttonTextConfirm}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};